import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function CustomPlanDialog({ open, onOpenChange, defaultName = "", institutionName = "" }) {
  const [form, setForm] = useState({ courses: "", name: defaultName, email: "" });
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!form.courses || !form.name || !form.email) {
      toast.error("Please fill in all fields");
      return;
    }
    setBusy(true);
    try {
      await api.post("/public/custom-plan-request", { ...form, institution_name: institutionName });
      toast.success("Request sent! Our team will get back to you shortly.");
      onOpenChange(false);
      setForm({ courses: "", name: defaultName, email: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader><DialogTitle>Request a Custom Listing Plan</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500">Need to list more than 50 courses? Tell us your requirement and we'll prepare a tailored plan for you.</p>
        <div className="space-y-3">
          <div>
            <Label className="mb-1.5 block">How many courses?</Label>
            <Input type="number" min="1" value={form.courses} onChange={(e) => set("courses", e.target.value)} placeholder="e.g. 120" data-testid="custom-plan-courses" />
          </div>
          <div>
            <Label className="mb-1.5 block">Your name</Label>
            <Input value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="Full name" data-testid="custom-plan-name" />
          </div>
          <div>
            <Label className="mb-1.5 block">Email</Label>
            <Input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="you@example.com" data-testid="custom-plan-email" />
          </div>
        </div>
        <DialogFooter>
          <Button className="bg-blue-800 hover:bg-blue-900" onClick={submit} disabled={busy} data-testid="custom-plan-submit">
            {busy ? "Sending..." : "Send Request"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
